import React, { createContext, useEffect } from 'react';
import useDataStore from "./useDataStore";

const DataContext = createContext();

export function DataProvider({ children }) {
  const { data, fetchData } = useDataStore();
  //
  // useEffect(() => {
  //   fetchData();
  // }, []);

  // const data = {};

  return <DataContext.Provider value={{ data }}>
    {children}
  </DataContext.Provider>;
}
